import * as React from 'react';
import {
    Create,
    TextInput,
    SimpleForm,
    minValue,
    DateTimeInput,
    required,
    useDataProvider,
} from 'react-admin';
import { AutocompleteInput } from 'react-admin';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InfoModal from './InfoModal';
import { Programs } from "../../custom";
import { validateNotEmpty } from '../../common/VideoPlayer/util';

export const SegmentRender = (choice: any) => `${choice.name}`;

const CampaignCreate = () => {
    const [open, setOpen] = React.useState(false);
    const [segments, setSegments] = React.useState<Programs[]>([]);
    const dataProvider = useDataProvider();

    React.useEffect(() => {
        dataProvider
            .getList<Programs>('segmentations', {
                pagination: { page: 1, perPage: 100 },
                sort: { field: 'name', order: 'ASC' },
                filter: {},
            })
            .then(({ data }) => setSegments(data))
            .catch((error) => console.error(error));
    }, [dataProvider]);

    return (
        <>
            <Create redirect={'/campaigns'}>
                <SimpleForm>
                    <div
                        onClick={() => setOpen(true)}
                        className="w-full px-5 flex flex-row gap-1 items-center justify-end"
                    >
                        <InfoOutlinedIcon
                            className="cursor-pointer my-3 justify-end"
                            sx={{ color: 'blue' }}
                        />
                        <p>info </p>
                    </div>

                    <TextInput source="name" fullWidth validate={[required(), validateNotEmpty]} />
                    <TextInput source="title" fullWidth validate={[required(), validateNotEmpty]} />
                    <TextInput
                        source="message"
                        fullWidth
                        validate={[minValue(0)]}
                        multiline
                        rows={5}
                    />
                    <DateTimeInput source="startsAt" validate={[required()]} fullWidth />

                    <AutocompleteInput
                        source="segmentId"
                        choices={segments}
                        optionText={SegmentRender}
                        fullWidth
                        isRequired
                    />
                </SimpleForm>
            </Create>
            <InfoModal open={open} setOpen={setOpen} />
        </>
    );
};

export default CampaignCreate;
